import { useEffect } from 'react';
import { api } from '../services/api.ts';
import { useUi } from '../state/ui.store.ts';

/**
 * Probe `/api/health` on first paint. If unreachable, surface a persistent
 * toast so the user knows to start the edge worker. The 404 / connect failure
 * otherwise propagates as a generic `http_404` deeper in the flow.
 */
export function useEdgeHealth(): void {
  const pushToast = useUi((u) => u.pushToast);

  useEffect(() => {
    const ctrl = new AbortController();
    const t = setTimeout(() => ctrl.abort(), 2000);

    void (async () => {
      try {
        await api('/health', { headers: {}, raw: false } as never);
        clearTimeout(t);
      } catch {
        clearTimeout(t);
        pushToast({
          kind: 'error',
          ttlMs: 30_000,
          message:
            'edge worker unreachable — run `pnpm dev` from the repo root',
        });
      }
    })();

    return () => {
      clearTimeout(t);
      ctrl.abort();
    };
  }, [pushToast]);
}
